module.exports = __webpack_public_path__ + "img/8.ccabc341.png";